module.exports = __webpack_public_path__ + "assets/img/home-servicePrice-zy-light.68f6ee35.png";